export const generalSessionTimerConstants = {
  sessionTimerHeading: 'Session Will Expire In',
  minutesLabel: 'Min',
  warningLimitInSeconds: 60,
  interval: 1000,
  modalTitle: 'Your session is about to expire',
  modalMessage1:
    'Your session is about to expire. You will be automatically signed out in:',
  modalMessage2:
    'To continue your session, Re-enter your password and click on Keep me signed in',
  tempModalCloseBtnText: 'Ok',
  tempSignInBtnText: 'Keep me Signed In',
  tempContinueBtnText: 'Continue Session',
};
